import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { LoadMoreStoriesBase, LoadMoreCollectionStories, Collection } from "@quintype/components";
import PropTypes from "prop-types";
import { OneMainCardSlider } from "../layout/one-main-card-slider.js";
import { FullscreenStoryList } from "../layout/fullscreen-story-list.js";
import { ThreeStoryCards } from "../layout/three-story-cards.js";
import { OneStoryCardSixStoryList } from "../layout/onestorycard-sixstorylist.js";
import { CardGroup } from "../layout/card-group.js";
import { getCollectionTemplate } from "../get-collection-template";
import { overrideLayouts, updateStoriesWithAlternatives } from "../../utils";

class SectionPageBase extends React.Component {
  render() {
    return getCollectionLayout(this.props);
  }
}

export function getCollectionLayout(props) {
  const collectionData = get(props, ["data", "collection", "items"], []);

  const hasCollection = collectionData.some(collection => collection.type === "collection");

  const pbSectionData = get(props, ["config", "pagebuilder-config", "section", "selectedOptions"], []);
  const sectionName = get(props, ["data", "section", "name"], "");
  const activeSection = !!pbSectionData.find(section => section.value === sectionName);
  const customCollection = overrideLayouts(props.config, props.data.collection, "section", activeSection);

  if (hasCollection) {
    return (
      <Collection config={props.config} collection={customCollection} collectionTemplates={getCollectionTemplate} />
    );
  }
  const updatedCollectionWithAlternativesData = updateStoriesWithAlternatives(collectionData);
  return (
    <LoadMoreStories
      {...props}
      stories={updatedCollectionWithAlternativesData}
      languageDirection={get(props.config, ["theme-attributes", "language_direction"], "left")}
    />
  );
}
getCollectionLayout.propTypes = {
  config: PropTypes.object,
  data: PropTypes.object
};

function getCollectionConfig(collection, section) {
  const name = section ? section["display-name"] || section["name"] : collection.name;
  return {
    name: name,
    "collection-name": name,
    "collection-slug": collection.slug,
    "collection-color": collection.color
  };
}

export function getDefaultTemplate(config, props) {
  return (
    <div>
      <h1 style={{ display: "none" }}>{config["name"]}</h1>
      <CardGroup stories={props.stories.slice(0, 4)} config={config} />
      <OneMainCardSlider stories={props.stories.slice(4, 9)} config={config} />
      <ThreeStoryCards stories={props.stories.slice(9, 12)} config={config} />
      <OneStoryCardSixStoryList stories={props.stories.slice(12, 19)} config={config} />
      <FullscreenStoryList
        adSlot={true}
        config={config}
        stories={props.stories.slice(19)}
        onLoadMore={props.onLoadMore}
        noMoreStories={props.noMoreStories}
      />
    </div>
  );
}
getDefaultTemplate.propTypes = {
  stories: PropTypes.array,
  onLoadMore: PropTypes.func,
  noMoreStories: PropTypes.bool
};

function LoadMoreStoriesTemplate(props) {
  const config = getCollectionConfig(props.collection, props.section);
  return getDefaultTemplate(config, props);
}

export function LoadMoreStories(props) {
  const collection = get(props, ["data", "section", "collection"], null);
  const storyFields =
    "headline,subheadline,summary,sections,tags,author-name,author-id,authors,updated-at,last-published-at,published-at,updated-at,first-published-at,hero-image-metadata,hero-image-s3-key,story-content-id,slug,id,seo,story-template,url";
  const data = Object.assign({}, props.data, { stories: props.stories });
  const sectionId = get(props, ["data", "section", "id"], -1);
  const numStoriesToLoad = 10;

  return collection ? (
    <LoadMoreCollectionStories
      template={LoadMoreStoriesTemplate}
      collectionSlug={collection.slug}
      params={{ "item-type": "story" }}
      data={data}
      languageDirection={props.languageDirection}
      numStoriesToLoad={numStoriesToLoad}
    />
  ) : (
    <LoadMoreStoriesBase
      template={LoadMoreStoriesTemplate}
      fields={storyFields}
      params={{ "section-id": sectionId }}
      data={data}
      languageDirection={props.languageDirection}
      numStoriesToLoad={numStoriesToLoad}
    />
  );
}
LoadMoreStories.propTypes = {
  data: PropTypes.object,
  languageDirection: PropTypes.string,
  stories: PropTypes.array
};

function mapStateToProps(state) {
  return {
    config: state.qt.config
  };
}

export const SectionPage = connect(mapStateToProps)(SectionPageBase);
